// client/src/components/products/ProductCard.js
import React, { useState } from 'react';
import { useQuote } from '../../context/QuoteContext';

const ProductCard = ({ product }) => {
  const { openModal, addToQuoteList, quoteItems } = useQuote();
  const [justAdded, setJustAdded] = useState(false);

  const isInQuoteList = quoteItems.some((item) => item.id === product.id);

  const handleRequestQuote = (e) => {
    e.stopPropagation();
    openModal(product);
  };

  const handleViewSpecs = (e) => {
    e.stopPropagation();
    openModal({ ...product, openDetailsFirst: true });
  };

  const handleQuickAddToList = (e) => {
    e.stopPropagation();
    addToQuoteList(product, 1);
    setJustAdded(true);
    setTimeout(() => setJustAdded(false), 1400);
  };

  return (
    <div className="product-card-item" onClick={handleRequestQuote}>
      <div className="product-card-image">
        <img
          src={product.imageUrl || '/images/placeholder.png'}
          alt={product.name}
          loading="lazy"
        />
        <button
          type="button"
          className={`product-quick-add-btn ${isInQuoteList || justAdded ? 'in-list' : ''}`}
          onClick={handleQuickAddToList}
          title="Add to Multi-Product Quote List"
          aria-label={`Add ${product.name} to quote list`}
        >
          <i className={`fas ${justAdded || isInQuoteList ? 'fa-check' : 'fa-plus'}`}></i>
          <span>{justAdded ? 'Added' : isInQuoteList ? 'In Quote List' : 'Add to List'}</span>
        </button>
      </div>

      <div className="product-card-content">
        <p className="product-card-category">{product.category}</p>
        <h3 className="product-card-name">{product.name}</h3>
        {product.description && (
          <p className="product-card-snippet">{product.description}</p>
        )}

        <div className="product-card-cta-wrapper">
          <span className="product-card-cta">
            Request Quote <i className="fas fa-arrow-right"></i>
          </span>
          <button
            type="button"
            className="product-card-spec-btn"
            onClick={handleViewSpecs}
            title="View Product Details & Specifications"
          >
            <i className="fas fa-info-circle"></i> Specs
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
